import { registerLocaleData } from '@angular/common';
import localeEsCO from '@angular/common/locales/es-CO';
import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app.config';
import { AppComponent } from './app.component';

registerLocaleData(localeEsCO);

bootstrapApplication(AppComponent, appConfig).catch((err) => console.error(err));
